import CheckCircle from '@pe-libs/react-components/build/components/PeIcons/CheckCircle.svg';
import React from 'react';
import useStyles from './styles';

type Props = {
  message: string;
};

const CopyLinkSuccessMessage: React.FC<Props> = ({ message }) => {
  const styles = useStyles();

  return (
    <div className={styles.toastWrapper}>
      <CheckCircle />
      <div className={styles.successMessage}>{message}</div>
    </div>
  );
};

export default CopyLinkSuccessMessage;
